import React, { useContext, useEffect } from 'react'
import { Head } from '@notino/react-toolkit/exports/Head'
import { useIntl } from 'react-intl'

// utils
import { DEFAULT_LOCALE, getEnvironmentAndLocaleSpecificShopsConfig, getEnvironmentSpecificShopsConfig } from '../../../../appDefaults'
import { PAGE_LINKS } from '../../../../utils/helper'
import { AppContext } from '../../../../utils/appProvider'

// hooks
import useMessages from '../../../../hooks/useMessages'

const MyReservationsPageHead = () => {
	const { locale } = useIntl()
	const { messages } = useMessages()
	const { productionEnvironment } = useContext(AppContext)

	const defaultShop = getEnvironmentAndLocaleSpecificShopsConfig(productionEnvironment, DEFAULT_LOCALE)
	const currentShop = getEnvironmentAndLocaleSpecificShopsConfig(productionEnvironment, locale)
	const shops = getEnvironmentSpecificShopsConfig(productionEnvironment)
	const relativeLink = PAGE_LINKS['/salons/my-reservations'](locale)
	const currentPath = `${currentShop.url}${relativeLink}`

	const pageTitle = messages['SEO - My reservations page - meta title']
	const description = messages['SEO - My reservation page - meta description']
	const keywords = messages['SEO - My reservations page - meta keywords']

	useEffect(() => {
		document.title = pageTitle
	}, [pageTitle])

	// NOTE: defining children as array and using .flat() on it otherwise <Head> doesn't work properly
	// each item has to have unique 'key' because <Head/> iterates over the array
	const children = [
		// charset
		<meta key='charset' charSet='utf-8' />,

		// title
		<title key='title'>{pageTitle}</title>,

		// description
		<meta key='description' name='description' content={description} />,

		// keywords
		<meta key='keywords' name='keywords' content={keywords} />,

		<meta key='robots' name='robots' content='noindex, nofollow' />,

		// canonical and alternate
		<link key='canonical' rel='canonical' href={currentPath} />,
		shops.map((shop, id) => (
			<link key={`alternate-${id}`} rel='alternate' href={`${shop.url}${PAGE_LINKS['/salons/my-reservations'](shop.locale)}`} hrefLang={shop.lang} />
		)),
		<link key='x-default' rel='alternate' href={`${defaultShop.url}${PAGE_LINKS['/salons/my-reservations'](defaultShop.locale)}`} hrefLang='x-default' />
	]
		.flat()
		.filter(Boolean)

	return <Head>{children}</Head>
}

export default MyReservationsPageHead
